import React from 'react';
import { EnvelopeAtFill, MapFill, Whatsapp } from 'react-bootstrap-icons';
import { useTiendaConfig } from '../../hooks/useTiendaConfig';
import { useCompanyInfo } from '../../hooks/useCompanyInfo';
import getIcon from '../../utils/getIcon';
import { Container, Row, Col } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import img from '../../utils/cr1-logo.png';

function FooterPublic() {
  const { socialLinks, whatsappLink } = useTiendaConfig();
  const { companyData } = useCompanyInfo();
  const { idSucursal } = useParams();

  const getCurrentYear = () => {
    return new Date().getFullYear();
  };

  const getWhatsappUrl = () => {
    if (whatsappLink && typeof whatsappLink.url === 'string' && whatsappLink.url.trim() !== '') {
      return whatsappLink.url;
    }
    return '#';
  };

  // Menú de navegación rápido
  const navLinks = [
    { label: 'Inicio', path: `/${idSucursal || '1'}` },
    { label: 'Categorías', path: `/${idSucursal || '1'}/Catalogo` },
    { label: 'Sobre Nosotros', path: `/${idSucursal || '1'}/SobreNosotros` },
    { label: 'Contacto', path: `/${idSucursal || '1'}/Contacto` },
    { label: 'Preguntas Frecuentes', path: `/${idSucursal || '1'}/PreguntaFrecuentes` },
  ];

  return (
    <footer className="color-bg-primary py-5">
      <Container>
        {/* Logo y botón principal */}
        <div className="text-center mb-5">
          <img
            src={img}
            alt="Crisha Caps Logo"
            style={{ maxWidth: '180px' }}
            loading='lazy'
            className="mb-4"
          />
        </div>

        {/* 3 Columnas */}
        <Row className="g-4">
          {/* Columna 1: Redes Sociales */}
          <Col md={4}>
            <div className="h-100">
              <h5 className="fw-bold mb-4 color-secundary">Síguenos</h5>
              <p className="color-secundary mb-4">
                Mantente conectado con nosotros a través de nuestras redes sociales.
              </p>
              <div className="d-flex gap-3">
                {socialLinks.map((link, index) => (
                  <a
                    key={index}
                    href={link.url}
                    rel='noreferrer noopener'
                    target="_blank"
                    title={link.title}
                    className="d-flex align-items-center justify-content-center"
                    style={{
                      width: '45px',
                      height: '45px',
                      borderRadius: '50%',
                      backgroundColor: 'rgba(255,255,255,0.1)',
                      transition: 'all 0.3s ease'
                    }}
                  >
                    <span className="fs-5 color-secundary">{getIcon(link.url)}</span>
                  </a>
                ))}
              </div>
            </div>
          </Col>

          {/* Columna 2: Menú Rápido */}
          <Col md={4}>
            <div className="h-100">
              <h5 className="fw-bold mb-4 color-secundary">Menú Rápido</h5>
              <ul className="list-unstyled">
                {navLinks.map((link, index) => (
                  <li key={index} className="mb-2">
                    <Link
                      to={link.path}
                      className="color-secundary text-decoration-none d-inline-block py-1"
                      style={{ transition: 'color 0.3s' }}
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </Col>

          {/* Columna 3: Contacto */}
          <Col md={4}>
            <div className="h-100">
              <h5 className="fw-bold mb-4 color-secundary">Contacto</h5>
              <div className="d-flex flex-column gap-3">
                <div className="d-flex align-items-start">
                  <MapFill className='color-secundary me-3 mt-1' size={18} />
                  <div>
                    <p className="mb-0 color-secundary">{companyData.direccion}</p>
                    <p className="mb-0 small color-secundary">{companyData.ciudad} - {companyData.departamento}</p>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <Whatsapp className='color-secundary me-3' size={18} />
                  <a href={getWhatsappUrl()} target="_blank" rel="noreferrer" className="color-secundary text-decoration-none">
                    {companyData.telefono}
                  </a>
                </div>
                <div className="d-flex align-items-center">
                  <EnvelopeAtFill className='color-secundary me-3' size={18} />
                  <a href={`mailto:${companyData.email}`} className="color-secundary text-decoration-none">
                    {companyData.email}
                  </a>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <hr className="color-secundary my-5" />

        {/* Copyright */}
        <div className="text-center">
          <p className="small mb-0 text-white">
            &copy; {getCurrentYear()} Aurora Bags. Todos los derechos reservados.
          </p>
          <p className="small mb-0 text-white">
            Diseñado por <a href="https://tubisnez.netlify.app/" target="_blank" rel="noreferrer" className="fw-bold text-white text-decoration-none">TuBisnez</a>
          </p>
        </div>
      </Container>
    </footer>
  );
}

export default FooterPublic;
